import * as amplitude from '@amplitude/analytics-browser';

export const trackSubpageView = (pageUrl: string, utmParams: any) => {
  amplitude.track('SubpageView', {
    pageUrl,
    ...utmParams,
  });
};
